// import config from '../utils/config';
import actionTypes from './action-types';
import tclocal from '../ter/ter-consts-local-lib';
import ajax from '../utils/ajax-adapter';
import { ajax_fetch } from '../utils/frfr-ajax-fetch';
import { frfr_res_utils } from '../utils/frfr-res-utils';
import { local_storage_utils } from '../utils/frfr-webstorage-utils';
import counter from '../utils/counter-utils';
import { users_cache_set } from '../ter/ter-cache-utils';


export const errCatched = (error) => {
  // console.log(error);
  console.error(error);
}


export const actionRoute = (route) => {
  return (dispatch) => {
    // console.log('TEST rrr');
    dispatch({
      type: actionTypes.ROUTE_SET,
      payload: route
    });
    local_storage_utils.item_set('sastavljac_temp_route', route);
  };
};

export const actionRouteWithParams = (route, route_params) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.ROUTE_WITH_PARAMS_SET,
      payload: {
        route,
        route_params
      }
    });
    local_storage_utils.item_set('sastavljac_temp_route', route);
  };
};

export const actionRouteRefresh = (route) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.ROUTE_REFRESH });
  };
};
export const actionRouteSecondScreenClose = () => {
  return (dispatch) => {
    dispatch({ type: actionTypes.ROUTE_SECOND_SCREEN_CLOSE });
  };
};

export const actionZapamcenaRuta = (route) => {
  return (dispatch) => {
    // console.log('TEST');
    // let route = local_storage_utils.item_get('sastavljac_temp_route'); // sada je to async funkcija, promise
    local_storage_utils.item_get('sastavljac_temp_route')
      .then((route) => {
        if (typeof route === 'string' && route !== '') {
          let _route = route;
          if (_route === 'EDITOR' || _route === 'EXPORT') {
            // ako je u pitanju druga ili treca strana od TerTok koraka onda se vracamo na prvu
            _route = 'TER_NARUDZBE';
          }
          dispatch(actionRoute(_route));
        }
      })

  };
};


export const action_zdravo = () => {
  return (dispatch) => {
    // thunk
    // console.log('test action');
    dispatch({ type: 'ZDRAVO' });

  };
};


export const actionSpinnerGlobalShow = () => {
  // thunk
  return (dispatch) => {
    dispatch({
      type: actionTypes.SPINNER_GLOBAL_SHOW
    });
  };
}
export const actionSpinnerGlobalhide = () => {
  // thunk
  return (dispatch) => {
    dispatch({
      type: actionTypes.SPINNER_GLOBAL_HIDE
    });
  };
}


export const actionShowToast = (title, color) => {
  // v2
  // VARIJANTA TOASTA SA TRAKOM ZA VELIKE EKRANE
  return (dispatch) => {
    // console.log('DISPATCHED dispatchShowToast', title, color);
    // korak 1) odmah prikazuje toast
    let _color = '';
    if (typeof color === 'string') {
      _color = color;
    }
    let id = counter.getFreshInteger();
    let newToast = {
      id: id,
      notificationType: tclocal.INFO,
      color: _color,
      title: title,
      toastClosing: false,
      closed: false
    }
    dispatch({
      type: actionTypes.SHOW_TOAST,
      payload: newToast
    });
    // korak 1.5) dispatchuje action za uklanjanje toasta nakon 2 sekunde...
    setTimeout(() => {
      dispatch({
        type: actionTypes.ANIMATED_CLOSING_TOAST,
        payload: id
      });
    }, 4000);
    // korak 2) dispatchuje action za uklanjanje toasta nakon 2 sekunde...
    setTimeout(() => {
      dispatch({
        type: actionTypes.CLOSE_TOAST,
        payload: id
      });
    }, 6000);
  };
};


export const actionNotificationsFromSupervalidator = (errors) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.OBAVESTENJA_SUPERVALIDATOR,
      payload: errors
    })
  };
};


export const actionShowToast_v1 = (title) => {
  // STARA VARIJANA v1
  // VARIJANTA TOASTA SA TRAKOM ZA VELIKE EKRANE
  return (dispatch) => {
    // korak 1) odmah prikazuje toast
    dispatch({
      type: actionTypes.SHOW_TOAST,
      payload: title
    });
    // korak 1.5) dispatchuje action za uklanjanje toasta nakon 2 sekunde...
    setTimeout(() => {
      dispatch({ type: actionTypes.ANIMATED_CLOSING_TOAST });
    }, 4000);
    // korak 2) dispatchuje action za uklanjanje toasta nakon 2 sekunde...
    setTimeout(() => {
      dispatch({ type: actionTypes.CLOSE_TOAST });
    }, 6000);
  };
};

export const actionShowToastMobile = (title) => {
  // VARIJANTA TOASTA ZA MOBILNE
  return (dispatch) => {
    console.log('dispatching thunk actionShowToastMobile');
    // korak 1) odmah prikazuje toast
    dispatch({
      type: actionTypes.SHOW_TOAST,
      payload: title
    });
    // korak 2) dispatchuje action za uklanjanje toasta nakon 2 sekunde...
    setTimeout(() => {
      dispatch({ type: actionTypes.CLOSE_TOAST });
    }, 2000);
  };
};


export const actionShowModal = (content, options = {}) => {
  return (dispatch) => {
    // korak 1) odmah prikazuje toast
    dispatch({
      type: actionTypes.SHOW_MODAL,
      payload: {
        content,
        options
      }
    });
  };
};

export const actionCloseModal = () => {
  return (dispatch) => {
    // korak 1) odmah prikazuje toast
    dispatch({
      type: actionTypes.ANIMATED_CLOSE_MODAL
    });
    // korak 2) dispatchuje action za uklanjanje toasta nakon 2 sekunde...
    setTimeout(() => {
      dispatch({ type: actionTypes.CLOSE_MODAL });
    }, 300);

  };
};

export const actionUserListNeeded = () => {
  return (dispatch) => {
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    dispatch({ type: actionTypes.USER_LIST_FETCHING });

    // korak 2 - fetchujemo podatke
    ajax.getUserList()
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // korak 3 - zavrseno fetchovanje
        if (frfr_res_utils.is_srf(response)) {
          const res_payload = frfr_res_utils.srf_extract_payload(response);
          // console.log(response);
          dispatch({ type: actionTypes.USER_LIST_SUCCESS, payload: res_payload });
          if (users_cache_set(res_payload)) {
            dispatch(actionShowToast('Lista korisnika keširana', tclocal.GREEN));
          }
          // dispatch(actionShowToast('Sucess! :)'));
        } else {
          // console.log(response);
          dispatch({ type: actionTypes.USER_LIST_FAIL });
          dispatch(actionShowToast('Greska! :('));
        }
      })
      .catch(errCatched)

  };
};

export const actionUserCreate = (userData) => {
  return (dispatch) => {
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    dispatch({ type: actionTypes.USER_CREATE_FETCHING });

    // korak 2 - fetchujemo podatke
    // console.log(n)
    ajax.postUserCreate(userData)
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // korak 3 - zavrseno fetchovanje
        if (frfr_res_utils.is_srf(response)) {
          const res_payload = frfr_res_utils.srf_extract_payload(response);
          // console.log(response);
          dispatch({ type: actionTypes.USER_CREATE_SUCCESS, payload: res_payload })
          dispatch(actionShowToast('Korisnik uspešno dodat!', tclocal.GREEN));
          dispatch(actionRouteRefresh());
        } else {
          // console.log(response);
          dispatch({ type: actionTypes.USER_CREATE_FAIL });
          dispatch(actionShowToast('Greska! :(', tclocal.RED));
        }
      })
      .catch(errCatched)

  };
};

export const actionUserUpdate = (userData, id) => {
  return (dispatch) => {
    // korak 1 - dispetchujemo akciju uz prikaz spinera
    dispatch({ type: actionTypes.USER_UPDATE_FETCHING });

    // korak 2 - fetchujemo podatke
    // console.log(n)
    ajax.postUserUpdate(userData, id)
      .then(response => ajax_fetch.response_json_smart(response))
      .then((response) => {
        // korak 3 - zavrseno fetchovanje
        if (frfr_res_utils.is_srf(response)) {
          const res_payload = frfr_res_utils.srf_extract_payload(response);
          // console.log(response);
          dispatch({ type: actionTypes.USER_UPDATE_SUCCESS, payload: res_payload })
          dispatch(actionShowToast('Korisnik uspešno izmenjen!', tclocal.GREEN));
          dispatch(actionRouteRefresh());
        } else {
          // console.log(response);
          dispatch({ type: actionTypes.USER_UPDATE_FAIL });
          dispatch(actionShowToast('Greska! :(', tclocal.RED));
        }
      })
      .catch(errCatched)

  };
};

